import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBalanceData } from '../views/Cards/containers/AddBalance';

export const initialValues: IBalanceData = {
	balanceAmount: 0,
	giftCardNumber: 0,
	balanceToAdd: 0,
	token: ''
};

const addBalanceSlice = createSlice({
	name: 'addBalance',
	initialState: initialValues,
	reducers: {
		addBalance: (
			state: IBalanceData,
			action: PayloadAction<IBalanceData>
		) => ({
			...state,
			...action.payload
		})
	}
});

export const { addBalance } = addBalanceSlice.actions;
export default addBalanceSlice.reducer;
